import type { FormInstance, FormRule } from 'antd';

export const resetErrorsOnChange = (form: FormInstance, values: Record<string, unknown>) => {
  Object.keys(values).forEach((field) => {
    const error = form.getFieldError(field);

    if (error.length) {
      form.setFields([
        {
          name: field,
          errors: [],
        },
      ]);
    }
  });
};

export const requiredRule = (message = 'Required field'): FormRule => ({
  validator: (_, value) => {
    if (!value?.toString().trim().length) {
      return Promise.reject();
    }

    return Promise.resolve();
  },
  message,
});

export const requiredArrayRule = (message = 'Required field'): FormRule => ({
  validator: (_, value) => {
    if (!value?.length) {
      return Promise.reject();
    }

    return Promise.resolve();
  },
  message,
});

export const optionalPositiveDecimalRule = (message = 'Wrong format'): FormRule => ({
  validator: (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const numberRegex = /^\d+(\.\d{1,2})?$/;
    const numValue = Number(value);
    const isValid = numberRegex.test(value) && numValue > 0;

    return isValid ? Promise.resolve() : Promise.reject();
  },
  message,
});

export const optionalRtpRule = (message = 'Wrong range [40 - 99.99]'): FormRule => ({
  validator: (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const rtpRegex = /^\d{1,2}(\.\d{1,2})?$/;
    const numValue = Number(value);
    const isValid = rtpRegex.test(value) && numValue >= 40 && numValue <= 99.99;

    return isValid ? Promise.resolve() : Promise.reject();
  },
  message,
});
